import reject from 'lodash/reject'
import unionBy from 'lodash/unionBy'

import {LOCATION_CHANGE} from 'connected-react-router'
import {reducer} from './helpers'
import {
  ADD_LOCK,
  CANONICALIZE,
  DECANONICALIZE,
  DISABLE_MIN_NAV,
  ENABLE_MIN_NAV,
  HIDE_FOOTER,
  REMOVE_LOCK,
  SHOW_FOOTER,
  WINDOW_ONLOAD,
} from '../actions/site'

const addByKey = (array, item) => unionBy(array, [item], 'key')
const removeByKey = (array, item) => reject(array, {key: item.key})

const initialState = {
  isFooterVisible: true,
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case ADD_LOCK:
      return {lockWindow: addByKey(state.lockWindow, payload)}
    case CANONICALIZE:
      return {canonicalHref: payload}
    case DECANONICALIZE:
      return {canonicalHref: undefined}
    case DISABLE_MIN_NAV:
      return {minNavIsActive: false}
    case ENABLE_MIN_NAV:
      return {minNavIsActive: true}
    case SHOW_FOOTER:
      return {isFooterVisible: true}
    case HIDE_FOOTER:
      return {isFooterVisible: false}
    case LOCATION_CHANGE:
      return {next: payload.pathname, prev: state.next}
    case REMOVE_LOCK:
      return {lockWindow: removeByKey(state.lockWindow, payload)}
    case WINDOW_ONLOAD:
      return {windowOnloadFired: true}
    default:
      return null
  }
})
